import React from "react"
import { groq } from "next-sanity"
import { Flex } from "@chakra-ui/react"
import Layout from "@components/Layout/hoc/withCmsData"
import Helmet from "@components/Helmet"
import SideNav from "@components/SideNav"
import SnippetGrid from "@components/SnippetGrid"
import { bp } from "@utils/MediaQueries"
import { usePreviewSubscription } from "@utils/sanity"

export const query = groq`{
  "sideNav": *[_type == "sideNav" && title == "News"][0] {
    title,
    links[] {
      title,
      slug
    }
  },
  "articles": *[_type == "article" && references(*[_type == "articleType" && slug == $articleType]._id)] | order(publishDate desc) {
    title,
    slug,
    publishDate,
    snippet,
    "image": image.asset->url,
    articleContent,
    articleTypes[]-> {...}
  }
}`

const Articles: any = ({ preview, pageData: staticData, articleType }) => {
  // const { data: liveData } = usePreviewSubscription(query, {
  //   params: { articleType },
  //   initialData: staticData,
  //   enabled: true,
  // })

  const pageData = staticData

  return (
    <Layout>
      <Helmet title={"SKB Cases"} />
      <Flex
        alignItems="flex-start"
        padding={bp("0 20px 100px", null, "100px 2p5col")}
        flexDir={bp("column", null, "row")}
      >
        {pageData?.sideNav && (
          <SideNav
            title={pageData?.sideNav?.title || ""}
            links={pageData?.sideNav?.links || []}
          />
        )}
        <SnippetGrid data={pageData?.articles || []} />
      </Flex>
    </Layout>
  )
}

export default Articles
